jQuery(document).ready(function() {
  let cards = jQuery('.grid--services__card');
  if (cards.length) {
    cards.each(function() {
      let card = jQuery(this);
      let front = card.find('.grid--services__front');
      let back = card.find('.grid--services__back button');
      front.click(function() {
        card.addClass('flipped');
      });
      back.click(function() {
        card.removeClass('flipped');
      });
    });
  }
});
